import React, { useState } from 'react';
import "./Navbar.css"; 
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import Logo from '../../assets/Logo.png';

const CustomNavbar = () => {
  const [expanded, setExpanded] = useState(false); // State to control manual toggle

  // Smooth scroll function
  const scrollToSection = (e, id) => {
    e.preventDefault();
    setExpanded(false); // Smoothly close the navbar when a link is clicked

    const element = document.getElementById(id);
    if (element) {
      const offset = 80; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Navbar 
      expand="lg" 
      className="custom-navbar" 
      fixed="top"
      expanded={expanded} // Controlled component
      onToggle={(nextExpanded) => setExpanded(nextExpanded)}
    >
      <Container>
        <Navbar.Brand href="#home" onClick={(e) => scrollToSection(e, 'home')}>
           <img 
             src={Logo} 
             alt="MK Logo" 
             className="nav-logo-img"
           />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link href="#home" onClick={(e) => scrollToSection(e, 'home')}>Home</Nav.Link>
            <Nav.Link href="#about" onClick={(e) => scrollToSection(e, 'about')}>About Us</Nav.Link>
            <Nav.Link href="#capabilities" onClick={(e) => scrollToSection(e, 'capabilities')}>Capabilities</Nav.Link>
            <Nav.Link href="#products" onClick={(e) => scrollToSection(e, 'products')}>Products</Nav.Link>
            <Nav.Link href="#infrastructure" onClick={(e) => scrollToSection(e, 'infrastructure')}>Facilities</Nav.Link>
            <Nav.Link href="#journey" onClick={(e) => scrollToSection(e, 'journey')}>Our Journey</Nav.Link>
            <Nav.Link href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</Nav.Link>
          </Nav>
          
          <div className="d-flex align-items-center ms-lg-4 mt-3 mt-lg-0 pb-3 pb-lg-0">
            <Button 
              className="btn-orange-pill" 
              onClick={(e) => scrollToSection(e, 'contact')}
            >
              Get In Touch 
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;